import { Typography, FormAlertLabel } from '@frontend/design_system'
import { UploadFile } from 'ui/atoms/UploadFile'
import { PlusIcon } from 'ui/icons'
import styles from './styles.module.scss'
import { UploadDocumentsProps } from './types'
import { UserDocuments } from 'types/documents'
import { AGREEMENTS } from 'texts/agreements'
import { formats } from './constants'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { setNotificationMessage } from 'redux/notifications/slice'
import { DocumentType } from 'api/documents/types'

export const UploadDocuments = ({
  columns = 4,
  onChangeSelectedFiles,
  fileErrors,
  id,
}: UploadDocumentsProps) => {
  const dispatch = useDispatch()
  const handleUpload = (id: keyof typeof DocumentType, value: File[]) => {
    onChangeSelectedFiles({
      [DocumentType[id]]: [...value],
    } as UserDocuments)
  }

  const isError = useMemo(
    () => Object.values(fileErrors || {}).some((el) => el),
    [fileErrors]
  )

  return (
    <>
      <Typography
        Tag="ul"
        name="body2WMedium"
        color="grey500"
        className={styles['upload-rules']}
      >
        {AGREEMENTS.UPLOAD_GUIDE}
        <Typography Tag="li" color="grey500" name="body2WMedium">
          {AGREEMENTS.FILE_FORMATS}
        </Typography>
        <Typography Tag="li" color="grey500" name="body2WMedium">
          {AGREEMENTS.UPLOAD_LIMIT}
        </Typography>
      </Typography>
      <div className={styles['agreements-form']}>
        <div className={styles['form-item']}>
          <UploadFile
            initFiles={[]}
            onUpload={(value) => handleUpload(id, value)}
            multiple
            error={isError}
            onError={(error) => {
              dispatch(
                setNotificationMessage({
                  notificationMessage: error,
                  type: 'error',
                })
              )
            }}
            variant="large"
            columns={columns}
            label={
              <div className={styles.label}>
                <PlusIcon size="large" color="blue700" />
                <Typography name="body2WMedium" color="blue700">
                  {AGREEMENTS.CLICK_TO_UPLOAD}
                  <Typography Tag="p" name="body2WMedium" color="blue700">
                    {AGREEMENTS.OR_DRAG_AND_DROP}
                  </Typography>
                </Typography>
              </div>
            }
            formats={formats}
          />
        </div>
      </div>
      {isError && (
        <FormAlertLabel
          label="Please upload files"
          position="static"
          type="error"
          typographyName="body2WMedium"
        />
      )}
    </>
  )
}
